/**
 * removeTags helper for packageDetails
 */
// used in tests
export const removeTags = (text: string) => {
    const regex = /(<\/?s>)|(<[^>]*>)/g; // Group 1 OR Group 2
    return text.replace(regex, (_, g1) => g1 || '');
};
